
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M17.81 4.47C17.73 4.47 17.65 4.45 17.58 4.41C15.66 3.42 14 3 12.01 3C10.03 3 8.14999 3.47 6.43999 4.41C6.19999 4.54 5.89999 4.45 5.75999 4.21C5.62999 3.97 5.71999 3.66 5.95999 3.53C7.81998 2.52 9.85998 2 12.01 2C14.14 2 16 2.47 18.04 3.52C18.29 3.65 18.38 3.95 18.25 4.19C18.16 4.37 17.99 4.47 17.81 4.47ZM3.49998 9.72C3.39998 9.72 3.29999 9.69 3.20999 9.63C2.97999 9.47 2.92998 9.16 3.08998 8.93C4.07998 7.53 5.33999 6.43 6.83999 5.66C9.97999 4.04 14 4.03 17.15 5.65C18.65 6.42 19.91 7.51 20.9 8.9C21.06 9.12 21.01 9.44 20.78 9.6C20.55 9.76 20.24 9.71 20.08 9.48C19.18 8.22 18.04 7.23 16.69 6.54C13.82 5.07 10.15 5.07 7.28999 6.55C5.92999 7.25 4.78999 8.25 3.88999 9.51C3.80999 9.65 3.65998 9.72 3.49998 9.72ZM9.74999 21.79C9.61999 21.79 9.48998 21.74 9.39998 21.64C8.52998 20.77 8.05999 20.21 7.38999 19C6.69999 17.77 6.33999 16.27 6.33999 14.66C6.33999 11.69 8.87998 9.27 12 9.27C15.12 9.27 17.66 11.69 17.66 14.66C17.66 14.94 17.44 15.16 17.16 15.16C16.88 15.16 16.66 14.94 16.66 14.66C16.66 12.24 14.57 10.27 12 10.27C9.42999 10.27 7.33999 12.24 7.33999 14.66C7.33999 16.1 7.65999 17.43 8.26999 18.51C8.90999 19.66 9.34999 20.15 10.12 20.93C10.31 21.13 10.31 21.44 10.12 21.64C10.01 21.74 9.87999 21.79 9.74999 21.79ZM16.92 19.94C15.73 19.94 14.68 19.64 13.82 19.05C12.33 18.04 11.44 16.4 11.44 14.66C11.44 14.38 11.66 14.16 11.94 14.16C12.22 14.16 12.44 14.38 12.44 14.66C12.44 16.07 13.16 17.4 14.38 18.22C15.09 18.7 15.92 18.93 16.92 18.93C17.16 18.93 17.56 18.9 17.96 18.83C18.23 18.78 18.49 18.96 18.54 19.24C18.59 19.51 18.41 19.77 18.13 19.82C17.56 19.93 17.06 19.94 16.92 19.94ZM14.91 22C14.87 22 14.82 21.99 14.78 21.98C13.19 21.54 12.15 20.95 11.06 19.88C9.65999 18.49 8.88999 16.64 8.88999 14.66C8.88999 13.04 10.27 11.72 11.97 11.72C13.67 11.72 15.05 13.04 15.05 14.66C15.05 15.73 15.98 16.6 17.13 16.6C18.28 16.6 19.21 15.73 19.21 14.66C19.21 10.89 15.96 7.83 11.96 7.83C9.11998 7.83 6.51998 9.41 5.34998 11.86C4.95998 12.67 4.75999 13.62 4.75999 14.66C4.75999 15.44 4.82998 16.67 5.42998 18.27C5.52998 18.53 5.39998 18.82 5.13998 18.91C4.87998 19.01 4.58999 18.87 4.49998 18.62C4.00998 17.31 3.76998 16.01 3.76998 14.66C3.76998 13.46 3.99998 12.37 4.44998 11.42C5.77998 8.63 8.72998 6.82 11.96 6.82C16.51 6.82 20.21 10.33 20.21 14.65C20.21 16.27 18.83 17.59 17.13 17.59C15.43 17.59 14.05 16.27 14.05 14.65C14.05 13.58 13.12 12.71 11.97 12.71C10.82 12.71 9.88999 13.58 9.88999 14.65C9.88999 16.36 10.55 17.96 11.76 19.16C12.71 20.1 13.62 20.62 15.03 21.01C15.3 21.08 15.45 21.36 15.38 21.62C15.33 21.85 15.12 22 14.91 22Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-fingerprint`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconFingerprint

    ```js
    <b-new-b-icon-fingerprint />
    ```
</docs>


